import { SET_IS_LOGGED_IN, SET_LOGIN_ALERT_TYPE } from './actionTypes';

const defaultSessionInfo = {
  isLoggedIn: false,
};

const defaultAlert = {
  alertType: '',
  isVisible: false,
};

const sessionReducer = (
  state = defaultSessionInfo,
  { type = '', session = { isLoggedIn: false } } = {},
) => {
  switch (type) {
    case SET_IS_LOGGED_IN:
      return {
        ...state,
        ...session,
      };

    default:
      return state;
  }
};

const loginAlertReducer = (
  state = defaultAlert,
  { type = '', alert = { alertType: '', isVisible: false } } = {},
) => {
  switch (type) {
    case SET_LOGIN_ALERT_TYPE:
      return {
        ...state,
        ...alert,
      };

    default:
      return state;
  }
};

export { sessionReducer, loginAlertReducer };
